import { render, staticRenderFns } from "./PaginatedAuditLog.vue?vue&type=template&id=45951262&"
import script from "./PaginatedAuditLog.vue?vue&type=script&lang=ts&"
export * from "./PaginatedAuditLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports